const messages = {
	_: {
		id: 'ID',
		name: 'Name',
		email: 'Email',
		phone: 'Telepon',
		point: 'Point',
		date: 'Date',
		title: 'Title',
		description: 'Description',
		province: 'Province',
		city: 'City',
		subdistrict: 'Subdistrict',
		receiptNumber: 'Receipt Number',
		coupon: 'Coupon',
		bump: 'Bump',
		productName: 'Product Name',
		qty: 'Quantity',
		status: 'Status',
		handledBy: 'Handled By',
		processingAt: 'Processing At',
		completedAt: 'Completed At',
		grossRevenue: 'Gross Revenue',
		paymentInfo: 'Payment Info',
		readMore: 'Read More',
		tutorials: 'Tutorials',
		fullname: 'Full Name',
		phoneNumber: 'Phone Number',
		language: 'Language',
		cogs: 'COGS',
		paymentStatus: 'Payment Status',
		checkoutPageName: 'Checkout Page Name',
		customFields: 'Custom Fields',
		tags: 'Tags',
		categories: 'Categories',
		processingDate: 'Processing Date',
		processingDateSince: 'Date Since',
		processingDateUntil: 'Date Until',
		completedDate: 'Completed Date',
		completedDateSince: 'Date Since',
		completedDateUntil: 'Date Until',
		shippingInfo: 'Shipping Info',
		variations: 'Variations',
		reseller: 'Reseller',
		tickets: 'Support Tickets',
		createCase: 'Create Case',
		optional: 'Optional',
		action: {
			edit: 'Edit',
			detail: 'View Detail',
		},
		courier: 'Courier',
		shippingCost: 'Shipping Cost',
		price: 'Price',
		hideCourier: 'Hide Courier Label',
		cancel: 'Cancel',
		close: 'Close',
	},
	global: {
		viewContactDetails: 'View Contact Details',
		contact: '0 Contact | 1 Contact | {count} Contacts',
		resellerTiers: '0 Tier | 1 Tier | {count} Tiers',
		resellerRewards: '0 Reward | 1 Reward | {count} Rewards',
		resellers: '0 Reseller | 1 Reseller | {count} Resellers',
		payment: '0 Payment | 1 Payment | {count} Payments',
		expenses: '0 Expenses | 1 Expenses | {count} Expenses',
		orders: '0 Order | 1 Order | {count} Orders',
		selected: 'Selected',
		delete: 'Delete',
		export: 'Export as CSV',
		filter: 'Filter',
		customizeColumn: 'Customize Columns',
		searchPlaceholder: 'Search..',
		cancel: 'Cancel',
		close: 'Close',
		apply: 'Apply',
		applyFilter: 'Apply Filter',
		submit: 'Submit',
		save: 'Save',
		setTag: 'Set Tag',
		maxSelectedTag: 'Max Selected Tag',
		actions: 'Actions',
		search: 'Search',
		pickupSupport: 'Pickup Support',
	},
	menu: {
		dashboard: 'Dashboard',
		dropship: 'Dropship',
		products: 'Products',
		submissions: 'Submissions',
		orders: 'Orders',
		coupons: 'Coupons',
		tutorials: 'Tutorials',
		createProduct: 'Create Product',
		admin: 'Admin Area',
		addons: 'Add-Ons',
		appStore: 'App Store',
		apps: 'Apps',
		bonus: 'Bonuses',
		myProfile: 'My Profile',
		profile: 'Profile',
		settings: 'Settings',
		support: 'Support',
		signout: 'Sign Out',
		changePlan: 'Change Plan',
		helpCenter: 'Help Center',
		payments: 'Payments',
		members: 'Team Members',
		reports: 'Reports',
		contacts: 'Contacts',
		expenses: 'Expenses',
		inventory: 'Inventory',
		others: 'Others',
		shipments: 'Shipments',
		resellers: 'Resellers',
		tickets: 'Support Tickets',
	},
	pc: {
		step: {
			product: 'Product',
			checkoutPage: 'Checkout Page',
			successPage: 'Success Page',
			done: 'Done',
		},
	},
	settings: {
		stock: {
			deductionDesc: "When the product's stock will be reduced",
			restoreDesc: "When the product's stock will be restored",
		},
		shipping: {
			autoPickup: 'Auto Change Status When Request Pickup',
			autoDelivered: 'Auto Change Status when Delivered',
			requestPickupDesc: 'Change status automatically when request pickup',
			deliveredStatusDesc: 'Change status automatically when delivered',
		},
	},
	contact: {
		title: 'Contacts',
		list: 'Contact List',
		detail: 'Contact Detail',
		create: 'Add Contact',
		update: 'Update Contact',
		reminder: {
			title: 'Reminder',
			link: 'Reminder',
			create: 'Create Reminder',
		},
		deleteTitle: 'Delete Contact',
		tag: 'Tags',
		tagCreate: 'Add Tag',
		setTag: 'Set Tag',
		name: 'Name',
		email: 'Email',
		emailTo: 'To',
		emailFrom: 'From',
		emailSubject: 'Subject',
		sendEmail: 'Send Email',
		emptyEmailIntegrate: 'Update this contact email address to enable email sender.',
		note: 'Note',
		createNote: 'Create Note',
		whatsapp: 'Whatsapp',
		sendWa: 'Send Whatsapp',
		whatsappIntegrate: 'Integrate WhatsApp Gateway',
		emptyWaIntegrate:
			'Integrate your WhatsApp gateway account to enable WhatsApp sender feature',
		sms: 'SMS',
		sendSms: 'Send SMS',
		emptySMSIntegrate: 'Integrate your SMS gateway account to enable SMS sender feature',
		smsIntegrate: 'Integrate SMS Gateway',
		phone: 'Phone',
		phoneTabLabel: 'Call',
		callPhone: 'Make A Phone Call',
		phoneCallInstruction: 'Use this Phone Call feature directly from your mobile phone',
		emptyPhone: 'Update this contact phone number to enable call',
		scheduleDate: 'Date',
		scheduleTitle: 'Title',
		province: 'Province',
		city: 'City',
		subdistrict: 'Subdistrict',
		address: 'Address',
		date: 'Date',
		lastContacted: 'Last Contacted',
		owner: 'Contact Owner',
		detailAbout: 'About This Contact',
		action: {
			edit: 'Edit',
			detail: 'View Detail',
		},
		export: 'Export',
		empty: {
			data: 'No contacts was found',
			filter: 'You have no contacts in this date range.',
		},
		deleteConfirm: 'Are you sure want to delete',
		filterContact: 'Filter Contact',
		buyerStatus: 'Buyer Status',
		maxSelectedTag: 'You can only select 5 tags for this contact',
		noPhoneCountry: 'No country phone prefix found',
		addModalTitle: 'Add New Contact',
		editModalTitle: 'Edit Existing Contact',
		type: 'Type',
		validate: {
			name: 'Name is required !',
			phone: 'You must input email or phone !',
			email: 'You must input email or phone !',
		},
		activity: 'Activity',
		emptyAcitivity: 'No Activity.',
		ltv: 'Lifetime Value (LTV)',
		ltvHistory: 'View History',
		ltvTitle: 'Lifetime Value History',
		ltvOrderId: 'Order Id',
		ltvProductName: 'Product Name',
		ltvDate: 'Date',
		ltvTotalPrice: 'Total Price',
		detailOther: 'Others',
		metaBrowser: 'Browser',
		metaDeviceType: 'Device Type',
		metaOs: 'Operating System',
		metaReferrer: 'Referrer URL',
		paidOrders: 'Paid Orders',
		product: 'Product',
		contactOwner: 'Contact Owner',
	},
	expenses: {
		title: 'Expenses',
		list: 'Expenses List',
		create: 'Add Expenses',
		name: 'Name',
		amount: 'Amount',
		action: {
			edit: 'Edit',
			detail: 'View Detail',
		},
		addTitle: 'Add New Expense',
		editTitle: 'Edit Expense',
		addSourceTitle: 'Add New Expense Source',
		editSourceTitle: 'Edit Expense Source',
		deleteTitle: 'Delete Expense',
		type: 'Type',
		product: 'Product',
		description: 'Description',
		date: 'Expense Date',
		created_at: 'Created Date',
		fb: {
			integrate: 'Integrate Facebook Account',
			empty: 'Integrate your Facebook account to generate automatic Facebook Ads expenses',
		},
		empty: {
			filter: 'You have no expenses in this date range.',
			data: 'No expense was found',
		},
		deleteConfirm: 'Are you sure want to delete',
		filterTitle: 'Filter Expense',
		filterDate: 'Expense Date',
		filterDateSince: 'Date Since',
		filterDateUntil: 'Date Until',
		tag: 'Tags',
		maxSelectedTag: 'You can only select 5 tags',
		tagCreate: 'Add Tag',
		setTag: 'Set Tag',
		amaount: 'Amount',
		note: 'Note',
		validate: {
			name: 'Name is required !',
			amount: 'Amount is required !',
			product: 'You must select product',
			adAccount: 'You must select ad account',
			campaign: 'You must select campaign',
		},
		titleSource: 'Automatic Expense List',
		createSource: 'Automatic Expense',
		createSourceLink: 'Automatic Expense List',
		source: 'Source',
		emptySource: 'No things found',
		adAccount: 'Ad Account',
		adAccountName: 'Ad Account Name',
		emptyAdAccount: 'No ad account found',
		campaign: 'Campaign',
		campaignName: 'Campaign Name',
		emptyCampaign: 'No campaign found',
		loadMore: 'Load More ...',
		includeTax: 'Include TAX',
		includePpn: 'Include PPN',
	},
	reminder: {
		mainTitle: 'Reminder',
		link: 'Reminder',
		create: 'Create Reminder',
		createNote: 'Create Note',
		sendMessage: 'Send Message',
		sendEmail: 'Send Email',
		sendSMS: 'Send SMS',
		sendWhatsapp: 'Send Whatsapp',
		add: 'Add Reminder',
		maxSelectedWa: 'Max Selected 50 Contacts',
		date: 'Date',
		title: 'Title',
		desc: 'Description',
		name: 'Name',
		phone: 'Phone',
		email: 'Email',
		lastContacted: 'Last Contacted',
		empty: {
			data: 'No reminder was found',
			filter: 'You have no reminders in this date range.',
		},
	},
	product: {
		add: 'Add Product',
		empty: 'No Product Found',
	},
	profile: {
		changePassword: 'Change my password',
		saveProfile: 'Save my profile',
		emailInfo: 'used to Sign In',
		changeEmail: 'Change Email',
		newEmail: 'New Email',
		changePhoneNumber: 'Change Phone Number',
		submit: 'Submit',
	},
	barcode: {
		label: 'Barcode Value',
		orderId: 'Order ID',
		number: 'No.',
		name: 'Name',
		status: 'Status',
		receipt: 'Receipt',
		noReceipt: 'Scan Without Receipt ',
		withReceipt: 'Scan With Receipt',
		empty: 'Scan your shipping label barcode to start updating order status to Completed',
		emptyReceipt: 'Scan your shipping label and receipt number barcode to start updating order status to Completed',
		title: 'Barcode Scanner',
		receiptNumber: 'Receipt Number',
		bactToOrder: 'Back to Order\'s Page',
	},
	members: {
		schedule: {
			status: 'Status',
			day: 'Day',
			start: 'Start Time',
			end: 'End Time',
		},
	},
	resellers: {
		manual_register: 'Add Manually',
		register_link: 'Register from Storefront',
		back_to_reseller: 'Back to Reseller',
		pending: 'Pending Activation',
		enable_register: 'Enable visitor to create reseller account on your store',
		csv_example: 'Download Example CSV File',
		limit: 'Your resellers have reached the limit. upgrade your plan. current reseller: {count}/{limit}',
		list: 'Reseller List',
		create: 'Add Reseller',
		name: 'Nama',
		total_commission: 'Total Commission',
		total_reseller_margin: 'Total Margin',
		email: 'Email',
		phone: 'Phone',
		revenue: 'Revenue',
		action: {
			edit: 'Edit',
			detail: 'Detail',
			accept: 'Accept',
			pending: 'Pending',
			delete: 'Delete',
			permanent_delete: 'Permanent Delete',
		},
		title: 'Resellers',
		source_type: 'Type',
		addModalTitle: 'Add Reseller',
		editModalTitle: 'Edit Reseller',
		upload: 'Upload Resellers',
		deleteConfirm: 'Are you sure want to delete',
		deleteTitle: 'Delete Reseller',
		sales_quantity: 'Sales Qty',
		total_price: 'Total Price',
		paid: 'Paid',
		orders: 'Orders',
		tier: {
			title: 'Tiers',
			name: 'Tier',
			list: 'Tier List',
			deleteTitle: 'Delete Reseller Tier',
			discount_type: 'Discount Type',
			discount_value: 'Discount Value',
			commission_type: 'Commission Type',
			commission_value: 'Commission Value',
			create: 'Add New Tier',
			addModalTitle: 'Buat Tier Baru',
			editModalTitle: 'Ubah Tier',
			deleteConfirm: 'Are you sure want to delete',
			action: {
				edit: 'Edit',
				detail: 'Detail',
			},
			empty: {
				filter: 'No Data Found',
				data: 'No Available Data',
			},
			threshold_type: 'Threshold Type',
			threshold_value: 'Treshold Value',
			level: 'Level',
			discount_max: 'Maximum Discount',
			validate: {
				name: 'Name cannot empty',
				discount_type: 'Discount Type cannot empty',
				discount_value: 'Discount Value cannot empty',
				auto_upgrade: 'Auto Upgrade',
				threshold_type: 'Threshold type cannot empty',
				threshold_value: 'Threshold value cannot be empty',
				level: 'Level {level} already exist',
				empty: 'Tier is empty, please add tier before creating reseller',
			},
			auto_upgrade: 'Auto Upgrade',
			threshold_types: {
				transaction: 'Total Transactions',
				revenue: 'Total Revenues',
				quantity: 'Total Quantity',
				not_set: 'Not Set',
			},
			placeholder: 'Select Tier',
		},
		enable_local_commission_type: 'Override general commission type only for this product',
		enable_local_reseller_product_tier: 'Override Reseller Tier only for this product',
		desc_local_commission_type: '',
		desc_local_reseller_type: '',
		type_placeholder: 'Select Commission Type',
		settings: {
			title: 'Reseller Settings',
			commission_type: 'Commission Type',
			reseller_tier: 'Reseller Tier',
			discount: 'Discount',
			commission: 'Commission',
		},
		filterReseller: 'Filter Reseller',
		reward: {
			title: 'Rewards',
			name: 'Reward',
			list: 'Reward List',
			deleteTitle: 'Delete Reward',
			create: 'Add New Reward',
			addModalTitle: 'Create New Reward',
			editModalTitle: 'Edit Reward',
			deleteConfirm: 'Are you sure want to delete',
			point: 'Point',
			status: 'Status',
			type: 'Type',
			action: {
				edit: 'Edit',
				detail: 'Detail',
			},
			empty: {
				filter: 'No Data Found',
				data: 'No Available Data',
			},
			validate: {
				name: 'Name cannot empty',
			},
			placeholder: 'Select Reward',
			desc_point: 'Add reward point for reseller',
			request: 'Reward Request',
		},
		exchange: {
			pending: 'Mark as Pending',
			process: 'Mark as Process',
			complete: 'Mark as Complete',
			refund: 'Mark as Refund',
			cancel: 'Mark as Cancel',
		},
		alert: {
			bulkTier: 'Please be aware, that this settings will override all tier on the selected resellers.',
		},
	},
	tickets: {
		create: 'Create Ticket',
		filterTitle: 'Filter Tickets',
		subject: 'Subject',
		message: 'Message',
		type: 'Type',
		topic: 'Topic',
		status: 'Status',
		priority: 'Priority',
		created_at: 'Created At',
		empty: {
			filter: 'You have no tickets in this date range.',
			data: 'No tickets was found',
		},
		detail: 'Ticket Detail',
		id: 'Ticket ID',
		reply: 'Reply',
	},
	dropship: {
		add: 'Add Product',
		sell: 'Sell Produk',
	},
	'Private Order Feature': 'Wholesale Order Feature',
};

export default messages;
